import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Home from "./pages";
import React from "react";
import Provider from "./AppContext"



function App() {
  return (
      <Provider>
          <Router>
              <Switch>
                  <Route path="/" component={Home} exact/>
              </Switch>
          </Router>
      </Provider>

  );
}

export default App;
